import React, { useCallback, useMemo } from 'react';

import { dealTypeFromJsonQuery } from '../../utils/category';
import { selectAllOfferTypes, setDealType } from '../../actions/filters';
import { FiltersTabs } from '../../components/FiltersTabs';
import { isOnlyLandTypeSelected } from '../../utils/jsonQuery/isOnlyLandTypeSelected';
import { useDispatch, useSelector } from 'react-redux';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { FILTER_TABS } from '../../constants/filters/tabs';
import { EDealType } from '../../utils/jsonQuery';
import { TThunkDispatch } from '../../types/redux';

export const FiltersTabsContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);

  const dispatch: TThunkDispatch = useDispatch();

  const selectedDealType = dealTypeFromJsonQuery(jsonQuery);

  const onDealTypeSelect = useCallback(
    (_: React.MouseEvent<HTMLButtonElement>, dealType: EDealType) => {
      dispatch(setDealType(dealType));
    },
    [dispatch],
  );

  const items = useMemo(
    () => [
      {
        label: FILTER_TABS[EDealType.Sale],
        isSelected: selectedDealType === EDealType.Sale,
        clickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          onDealTypeSelect(event, EDealType.Sale);
        },
      },
      {
        label: FILTER_TABS[EDealType.RentLongterm],
        isSelected: selectedDealType === EDealType.RentLongterm,
        clickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          onDealTypeSelect(event, EDealType.RentLongterm);

          if (isOnlyLandTypeSelected(jsonQuery)) {
            dispatch(selectAllOfferTypes());
          }
        },
      },
      {
        label: 'Продать',
        url: '/razmestit-obyavlenie/',
      },
      {
        label: 'Построить',
        url: '/country-builders-projects/?utm_medium=zagorod&utm_content=bookmark',
      },
    ],
    [dispatch, jsonQuery, onDealTypeSelect, selectedDealType],
  );

  return <FiltersTabs items={items} />;
};
